<template>
  <div class="app">
    <Loader v-if="mode === 'loader'"/>
    <Body  v-if="mode === 'body'"/>
    <HealthCheck v-if="mode === 'first-check' || mode === 'second-check'"/>
    <Player v-if="mode === 'player'"/>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import Body from '@/components/Body/Body.vue';
import Loader from '@/components/Loader/Loader.vue';
import HealthCheck from '@/components/HealthCheck/HealthCheck.vue';
import Player from '@/components/Player/Player.vue';
import { nanoid } from 'nanoid';

export default {
  name: 'Main',
  data() {
    return {
      pageTitle: 'Закалка',
    };
  },
  components: {
    Player,
    HealthCheck,
    Loader,
    Body,
  },
  computed: {
    mode() {
      return this.$store.getters['app/getMode'];
    },
  },
  methods: {
    ...mapMutations({
      setMode: 'app/setMode',
      setUserId: 'app/setUserId',
      setDoneMeditation: 'app/setDoneMeditation',
    }),
    ...mapActions({
      fetchData: 'app/fetchData',
    }),

    setUser() {
      if (!localStorage.getItem('NLMK_USER')) {
        localStorage.setItem('NLMK_USER', nanoid());
      }

      this.setUserId(localStorage.getItem('NLMK_USER'));
    },
  },
  mounted() {
    document.title = this.pageTitle;
  },
  created() {
    this.setUser();
    this.fetchData();
    if (localStorage.getItem('NLMK_PROGRESS')) {
      const progressArray = JSON.parse(localStorage.getItem('NLMK_PROGRESS'));

      this.setDoneMeditation(progressArray);
    }
  },
};
</script>
